import { useQuery } from '@tanstack/react-query';
import { listProbeLogs } from '../api/probe-logs.api.ts';
import type { ProbeLogListParams } from '@/shared/types/probe-log.ts';

export const probeLogKeys = {
  all: ['probe-logs'] as const,
  list: (params: ProbeLogListParams) => [...probeLogKeys.all, 'list', params] as const,
};

export function useProbeLogList(params: ProbeLogListParams, enabled = true) {
  return useQuery({
    queryKey: probeLogKeys.list(params),
    queryFn: () => listProbeLogs(params),
    enabled,
  });
}
